import { render, staticRenderFns } from "./SidebarHead.vue?vue&type=template&id=66bd5312&"
import script from "./SidebarHead.vue?vue&type=script&lang=js&"
export * from "./SidebarHead.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./SidebarHead.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports